import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {Creature, LevelUpDto} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import TextUtils from "@/utils/text-utils";
import SkillUtils from "@/utils/skill-utils";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import {Fonts} from "@/constants/font";
import PlayerStore from "@/store/player";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class LevelUpPanel extends VerticalStandardPanel {

    private callback: ((id: number) => unknown) | undefined = undefined;

    private leftCreaturePanel: CreaturePanel | undefined;
    private rightCreaturePanel: CreaturePanel | undefined;

    private onCreatureUpdateCallback!: (creatureId: number) => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, creaturesId: number[], level: number, levelUpDto: LevelUpDto,
                onCreatureUpdateCallback: (creatureId: number) => unknown) {
        super(scene, canvas, Tr('uroven').toUpperCase() + ' ' + (level + 1).toString());

        this.onCreatureUpdateCallback = onCreatureUpdateCallback;

        let shiftX = 0;
        let addition = (levelUpDto.skillAddition && levelUpDto.skillAddition > 0) ? (' +' + SkillUtils.formatHealth(levelUpDto.skillAddition)) : undefined;
        if (addition) {
            shiftX = -25;
        }

        let infoText = TextUtils.addTextByFamily(scene, Tr('vi.poluchaete.noviy.uroven').toUpperCase(),
            0, -175, '#ffd465', 17, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let levelUpFlourish = SpriteUtils.addSprite(this.scene, 0, -140, Keys.ATLAS_UI, Keys.IMG_LEVELUP_ICON)
            .setAlpha(0.1)
            .setOrigin(0.5, 0.3);
        SpriteUtils.setDispSize(levelUpFlourish, 301 * CU.S, 247 * CU.S);

        let skillIcon = SpriteUtils.addSprite(this.scene, 0, -90, Keys.ATLAS_PROFILE, SkillUtils.getSkillIcon(levelUpDto.skillType));
        SpriteUtils.setDispSize(skillIcon, 100 * CU.S, 100 * CU.S);

        let skillTypeText = TextUtils.addTextByFamily(scene, SkillUtils.getSkillText(levelUpDto.skillType).toUpperCase() + ' +' + SkillUtils.formatHealth(levelUpDto.skillDelta),
            shiftX, -20, '#d4d4d4', 14, 'normal', 450, Fonts.ARIAL_MT);

        if (addition) {
            let skillAddition = TextUtils.addTextAdvanced(this.scene, addition, skillTypeText.getRightCenter().x! + 7, -20,
                '#68ff47', 14, 'normal', 200, 'left', 2, Fonts.ARIAL_MT).setOrigin(0, 0.5);
            this.add(skillAddition);
        }

        let choseCreatureText = TextUtils.addTextByFamily(scene, Tr('viberi.kto.iz.geroev.poluchit.bonus').toUpperCase(),
            0, 35, '#e5e5e5', 14, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        this.leftCreaturePanel = new CreaturePanel(this.scene, -90, 145, this.getCreature(creaturesId[0]), () => {});

        this.rightCreaturePanel = new CreaturePanel(this.scene,110, 145, this.getCreature(creaturesId[1]), () => {});

        this.leftCreaturePanel.setCallback(() => this.onCreatureUpdateCallback(creaturesId[0]));
        this.rightCreaturePanel.setCallback(() => this.onCreatureUpdateCallback(creaturesId[1]));

        this.leftCreaturePanel.setHealthVisible();
        this.rightCreaturePanel.setHealthVisible();

        this.add([levelUpFlourish, infoText, skillTypeText, choseCreatureText, skillIcon,
            this.leftCreaturePanel, this.rightCreaturePanel]);

        this.xButton.setVisible(false);
    }

    public setCallback(callback: () => unknown): void {
        this.callback = callback;
    }

    private getCreature(creatureId: number): Creature {
        return PlayerStore.getPlayer().creatures.find((c: Creature) => c.id == creatureId)!;
    }

}
